import { Button } from '@/components/ui/button';
import { useArchiveNotification } from 'hooks/useUserNotifications';
import { isHardcodedFemaThunderboltInvite } from './femaThunderboltInvite';

/** Accept or decline the demo invite. Both clear it from the active inbox. */
export function FemaThunderboltInviteActions({
  notificationId,
  archived,
}: {
  notificationId: string;
  archived: boolean;
}) {
  const archiveNotification = useArchiveNotification();
  if (archived || !isHardcodedFemaThunderboltInvite(notificationId)) {
    return null;
  }
  const dismiss = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    void archiveNotification.mutateAsync({ notificationId });
  };

  return (
    <div className="tw:flex tw:flex-wrap tw:gap-1.5">
      <Button type="button" size="xs" onClick={dismiss}>
        Activate
      </Button>
      <Button type="button" size="xs" variant="outline" onClick={dismiss}>
        Decline
      </Button>
    </div>
  );
}
